import threeContainer from './3d-container.js'
import visualizer from './visualizer.js'
import rackTable from './rack-table.js'
import cube from './cube.js'
import cylinder from './cylinder.js'
import sphere from './sphere.js'
import banner from './banner.js'
import sprite from './sprite.js'
import wall from './wall.js'
import desk from './desk.js'
import camera from './camera.js'
import light from './light.js'
import GLTFObject from './gltf-object.js'
import signalTower from './signal-tower.js'
import tank from './tank.js'
import vehicle from './vehicle.js'
import carrier from './carrier.js'
import stockHub from './stock-hub.js'

export default [
  threeContainer,
  visualizer,
  stockHub,
  rackTable,
  camera,
  light,
  cube,
  cylinder,
  sphere,
  sprite,
  banner,
  wall,
  desk,
  GLTFObject,
  signalTower,
  tank,
  vehicle,
  carrier
]
